import axios, { type InternalAxiosRequestConfig } from 'axios';
import retrieveTgInitData from '../retrieveTgInitData';

// tg 鉴权：https://docs.telegram-mini-apps.com/platform/authorizing-user
const requestInterceptor = async ({
  url,
  baseURL = process.env.NEXT_PUBLIC_API_BASE_URL,
  ...config
}: InternalAxiosRequestConfig) => {
  const token = retrieveTgInitData();
  config.headers.Authorization = token ? `tma ${token}` : undefined;

  return {
    ...config,
    url,
    baseURL,
  };
};

const AXIOS_DEFAULT_CONFIG = {
  timeout: 20000,
};
const request = axios.create(AXIOS_DEFAULT_CONFIG);

request.interceptors.request.use(requestInterceptor);
request.interceptors.response.use(
  (resp) => {
    return resp?.data;
  },
  (e) => {
    if (
      (e?.code == 'ECONNABORTED' && e?.message.indexOf('timeout') != -1) ||
      e?.response?.status >= 500 ||
      e?.code === 'ERR_NETWORK'
    ) {
      throw {
        code: e.code,
        status: e.response?.status,
        message:
          e.response?.data?.message ||
          e.response?.data?.error?.message ||
          `Network problems, please refresh and try again.`,
      };
    }

    const data = e.response.data;
    if (typeof data === 'string') {
      throw {
        code: 'wrong',
        message: 'Oops, something wrong',
        status: e.response.status,
      };
    }

    const returnError = data.error ||
      data || { code: 'wrong', message: 'Oops, something wrong' };
    throw {
      ...returnError,
      status: e.response.status,
    };
  }
);

export default request;

const request2 = axios.create(AXIOS_DEFAULT_CONFIG);
request2.interceptors.request.use(requestInterceptor);
export { request2 };
